import { render, staticRenderFns } from "./ImprestCashComment.vue?vue&type=template&id=b561173e&scoped=true"
import script from "./ImprestCashComment.vue?vue&type=script&lang=js"
export * from "./ImprestCashComment.vue?vue&type=script&lang=js"
import style0 from "./ImprestCashComment.vue?vue&type=style&index=0&id=b561173e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b561173e",
  null
  
)

export default component.exports